import { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { api } from '../api';
import Ayuda from '../ui/Ayuda';
import { fechaCorta, pesos } from './dinero';

/* =====================================================================
   Tu dinero · ERP-OPERATIVO EF5 (era DESPEGUE F6): el tablero del dueño
   en pesos, con la fecha del dato al calce de cada número.
   ===================================================================== */
export default function TuDinero() {
  const [d, setD] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    let vivo = true;
    api.get('/finanzas/tablero').then((r) => { if (vivo) setD(r); }).catch((e) => { if (vivo) setError(e.message); });
    return () => { vivo = false; };
  }, []);
  if (error) return <p className="p-4 text-sm text-red-700">{error}</p>;
  if (!d) {
    return (
      <p className="flex items-center gap-2 p-4 text-sm text-gray-500">
        <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" /> Sumando…
      </p>
    );
  }
  const tarjetas = [
    ['Vendido', d.vendido, 'text-gray-900', `${d.vendido.documentos} venta(s) del ${d.periodo.desde} al ${d.periodo.hasta}`],
    ['Cobrado', d.cobrado, 'text-green-700', `${d.cobrado.documentos} cobro(s) en el periodo`],
    ['Pagado a proveedores', d.pagado_a_proveedores, 'text-red-700', 'en el periodo'],
    ['Por cobrar', d.por_cobrar, 'text-gray-900', `${d.por_cobrar.documentos} documento(s) · vencido ${pesos(d.por_cobrar.vencido)}`],
    ['Por pagar', d.por_pagar, 'text-gray-900', `${d.por_pagar.documentos} factura(s) · vencido ${pesos(d.por_pagar.vencido)}`],
    ['En bancos', d.en_bancos, 'text-gray-900', `${d.en_bancos.documentos} cuenta(s)`],
  ];
  return (
    <div className="flex max-w-5xl flex-col gap-5 p-4">
      <header>
        <h1 className="text-xl font-semibold text-gray-900">Caja y bancos hoy</h1>
        <p className="text-gray-600">Cinco números en pesos, y de cuándo es cada uno.</p>
        <Ayuda id="finanzas.tablero.pantalla" />
      </header>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {tarjetas.map(([etiqueta, n, tono, pie]) => (
          <div key={etiqueta} className="rounded-xl border border-gray-200 p-4">
            <div className="text-sm text-gray-600">{etiqueta}</div>
            <div className={`text-2xl font-semibold tabular-nums ${tono}`}>{pesos(n.monto)}</div>
            <div className="text-xs text-gray-500">{pie}</div>
            <div className="mt-1 text-xs text-gray-500">
              {n.dato_al ? `Último dato: ${fechaCorta(n.dato_al)}` : 'Sin datos registrados todavía'}
            </div>
          </div>
        ))}
      </div>
      <Ayuda id="finanzas.tablero.fecha_del_dato" />
    </div>
  );
}
